import {Attributes, AttributesRow, Card, Separator} from 'platform/components';
import {Grid, GridItem, VStack} from 'platform/foundation';

import {GetSupplierArticleResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {DEFAULT_PRICE, useTenant} from '@dms/shared';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SupplierArticlesAddNewCatalogInfoPrice} from './SupplierArticlesAddNewCatalogInfoPrice';

interface SupplierArticlesAddNewCatalogInfoProps extends RequiredTestIdProps {
  supplierArticle: GetSupplierArticleResponse | Nullish;
}

export function SupplierArticlesAddNewCatalogInfo(props: SupplierArticlesAddNewCatalogInfoProps) {
  const tenant = useTenant();
  const catalogInfo: AttributesRow[] = [
    {label: i18n.t('entity.warehouse.labels.name'), value: props.supplierArticle?.articleName},
    {label: i18n.t('entity.warehouse.labels.supplier'), value: props.supplierArticle?.supplierName},
    {
      label: i18n.t('entity.warehouse.labels.manufacturer'),
      value: props.supplierArticle?.manufacturerName,
    },
    {
      label: i18n.t('entity.warehouse.labels.supplierOrderingNumber'),
      value: props.supplierArticle?.supplierOrderingNumber,
    },
    {
      label: i18n.t('entity.warehouse.labels.catalogueNumber'),
      value: props.supplierArticle?.manufacturerNumber,
    },
    {
      label: i18n.t('entity.warehouse.labels.supplierDiscountGroup'),
      value: props.supplierArticle?.supplierDiscountGroupCode,
    },
    {
      label: i18n.t('entity.warehouse.labels.supplierBulkPackageQuantity'),
      value: props.supplierArticle?.supplierBulkPackageQuantity,
    },
  ];

  return (
    <VStack spacing={4}>
      <Card
        title={i18n.t('entity.warehouse.labels.catalogueInfo')}
        variant="inlineGrey"
        data-testid={props['data-testid']}
      >
        <Attributes
          rows={catalogInfo}
          size="quarter"
          data-testid={suffixTestId('attributes', props)}
        />

        <Separator />

        <Grid columns={4}>
          <GridItem span={1}>
            <SupplierArticlesAddNewCatalogInfoPrice
              label={`${i18n.t('entity.warehouse.labels.recommendedPrice')} ${i18n.t(
                'general.labels.w/oVat'
              )}`}
              price={props.supplierArticle?.recommendedPriceWithoutVat ?? DEFAULT_PRICE}
              currency={props.supplierArticle?.currency ?? tenant.tenantCurrency}
              data-testid={suffixTestId('prices.recommended', props)}
            />
          </GridItem>
          <GridItem span={1}>
            <SupplierArticlesAddNewCatalogInfoPrice
              label={`${i18n.t('entity.warehouse.labels.purchasePrice')} ${i18n.t(
                'general.labels.w/oVat'
              )}`}
              price={props.supplierArticle?.purchasePriceWithoutVat ?? DEFAULT_PRICE}
              currency={props.supplierArticle?.currency ?? tenant.tenantCurrency}
              data-testid={suffixTestId('prices.purchase', props)}
            />
          </GridItem>
        </Grid>
      </Card>
    </VStack>
  );
}
